import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="channel-click-up-chat"
export default class extends Controller {
  static targets = [
    "workspaceId",
    "channelId",
    "workspaceName",
    "channelName",
  ];

  static values = {
    projectId: Number,
    channelId: Number,
  }

  connect() {
    this.workspaceSelect = $(this.workspaceIdTarget);
    this.channelSelect = $(this.channelIdTarget);

    [this.workspaceSelect, this.channelSelect].forEach((select) => {
      select.attr('disabled', true);
    });

    this.loadWorkspaces();
    this.loadChannels(this.workspaceSelect.attr('value'));
  }

  loadWorkspaces() {
    this.workspaceSelect.attr('disabled', true).empty().append($("<option>Loading workspaces</option>"));
    this.loadData('/workspaces', this.workspaceSelect);
  }

  loadChannels(workspaceId) {
    if (workspaceId) {
      this.channelSelect.attr('disabled', true).empty().append($("<option>Loading channels</option>"));
      this.loadData(`/channels?workspace_id=${workspaceId}`, this.channelSelect);
    }
  }

  workspaceIdChanged() {
    this.channelSelect.attr('disabled', true).empty();
    this.workspaceNameTarget.value = this.workspaceSelect.find('option:selected').text();
    this.loadChannels(this.workspaceSelect.val());
  }

  channelIdChanged() {
    this.channelNameTarget.value = this.channelSelect.find('option:selected').text();
  }

  channelUrl(path) {
    return `/projects/${this.projectIdValue}/channels/${this.channelIdValue}/click_up_chat${path}`;
  }

  loadData(path, selectElements) {
    $.ajax(this.channelUrl(path), {
      type: 'get',
      dataType: 'json',
      success: (...args) => [].concat(selectElements).forEach((selectElement) => this.populateSelect(selectElement, ...args)),
      error: (...args) => this.reportError(...args),
    });
  }

  populateSelect(selectElement, items) {
    const selected = selectElement.attr('value');
    selectElement.empty();
    selectElement.append($('<option>'));
    items.forEach(item => {
      selectElement.append(
        $('<option>', {
          value: item.id,
          text: item.name,
          selected: item.id === selected,
        }),
      );
      selectElement.removeAttr('disabled');
    });
  }

  reportError(xhr, status, error) {
    if (error.match(/forbidden/i)) {
      alert('ClickUp Chat access denied: Invalid API Key');
    }
  }
}